// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");

function exact(baths) {
  return {
    baths: baths,
    bathsRange: false,
    minBaths: undefined,
    maxBaths: undefined
  };
}

function range(minBaths, maxBaths) {
  return {
    baths: undefined,
    bathsRange: true,
    minBaths: minBaths,
    maxBaths: maxBaths
  };
}

function hasInput(bathsState) {
  if (bathsState.bathsRange) {
    if (Stdlib_Option.isSome(bathsState.minBaths)) {
      return true;
    } else {
      return Stdlib_Option.isSome(bathsState.maxBaths);
    }
  } else {
    return Stdlib_Option.isSome(bathsState.baths);
  }
}

function toInput(bathsState) {
  return {
    bathsRange: bathsState.bathsRange ? ({
        maxBaths: bathsState.maxBaths,
        minBaths: bathsState.minBaths
      }) : undefined,
    exactBaths: bathsState.bathsRange ? undefined : ({
        baths: bathsState.baths
      })
  };
}

let empty = {
  baths: undefined,
  bathsRange: false,
  minBaths: undefined,
  maxBaths: undefined
};

exports.empty = empty;
exports.exact = exact;
exports.range = range;
exports.hasInput = hasInput;
exports.toInput = toInput;
/* No side effect */
